<template>
  <v-card flat class="yt-kpi">
    <div class="yt-kpi__label">
      <span>{{ label }}</span>
      <span v-if="hint" class="yt-kpi__hint" :title="hint">?</span>
    </div>
    <div class="yt-kpi__value">{{ value }}</div>
    <div v-if="sub" class="yt-kpi__sub">{{ sub }}</div>
    <div v-if="series && series.length > 1" class="yt-kpi__spark">
      <vue-apex-charts type="area" height="36" :options="options" :series="[{ name: label, data: series }]" />
    </div>
  </v-card>
</template>

<script>
import { computed } from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'
import { sparklineOptions, fInt } from './ytFormat'
import { RMR_INDIGO } from '@/styles/tokens'

export default {
  name: 'YtKpiTile',
  components: { VueApexCharts },
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true },
    sub: { type: String, default: '' },
    hint: { type: String, default: '' },
    series: { type: Array, default: () => [] },
    color: { type: String, default: RMR_INDIGO },
    formatter: { type: Function, default: fInt },
  },
  setup(props) {
    const options = computed(() => sparklineOptions(props.color, props.formatter))
    return { options }
  },
}
</script>

<style lang="scss" scoped>
.yt-kpi {
  border-radius: $rmr-radius-xl !important;
  padding: 12px 14px 8px;
  box-shadow: $rmr-shadow-card !important;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.yt-kpi__label {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 6px;
  font-size: $rmr-fs-sm;
  color: $rmr-text-secondary;
  font-weight: 600;
  line-height: 1.3;
  min-height: 2.6em;
}

.yt-kpi__hint {
  display: inline-grid;
  place-items: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid $rmr-border-hover;
  font-size: 10px;
  color: $rmr-text-subtle;
  cursor: help;
  flex: none;
}

.yt-kpi__value {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: $rmr-text-primary;
  line-height: 1.15;
  overflow-wrap: anywhere;
}

.yt-kpi__sub {
  font-size: $rmr-fs-xs;
  color: $rmr-text-subtle;
}

.yt-kpi__spark {
  margin-top: auto;
  padding-top: 4px;
}
</style>
